// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_ar-6";
export var headerCell = "_ar-2";
export var rowWrapper = "_ar-4";
export var stickyAggregationRow = "_ar-7";
export var table = "_ar-1";
export var virtualRowWrapper = "_ar-5";
export var virtualTableContainer = "_ar-0";
export var white = "_ar-3";